export default __webpack_public_path__ + "static/box-0d36112108c6957a38e266936f198a75.png";